'use client';

import { ColumnDef } from '@tanstack/react-table';

import { Link } from '@/components/link';
import { ApiSchemas } from '@/components/providers/v1-api';
import { Badge } from '@/components/ui/badge';
import { Checkbox } from '@/components/ui/checkbox';

type ApiEmployee = ApiSchemas['EmployeeRead'];

export const EMPLOYEE_COLUMNS: ColumnDef<ApiEmployee>[] = [
  {
    id: 'select',
    header: ({ table }) => (
      <Checkbox
        checked={table.getIsAllRowsSelected() || (table.getIsSomePageRowsSelected() && 'indeterminate')}
        onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
        aria-label='Select all'
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        checked={row.getIsSelected()}
        onCheckedChange={row.getToggleSelectedHandler()}
        onClick={(e) => e.stopPropagation()}
        aria-label='Select row'
      />
    ),
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: 'name',
    header: () => <div className='p-4'>Name</div>,
    cell: ({ row }) => {
      let name = '';
      if (row.original.first_name) {
        name += row.original.first_name;
      }
      if (row.original.last_name) {
        name += ' ' + row.original.last_name;
      }
      if (name === '') {
        name = 'No name';
      }
      return (
        <Link href={`/settings/employees/${row.original.id}`} className='inline-block px-4 font-medium hover:underline'>
          {name}
        </Link>
      );
    },
  },
  {
    header: 'Email',
    accessorKey: 'email',
  },
  {
    header: 'Role',
    accessorKey: 'role',
    cell: ({ row }) => {
      return <span className='capitalize'>{row.original.role.toLowerCase()}</span>;
    },
  },
  {
    header: 'Bookable',
    accessorKey: 'bookable',
    cell: ({ row }) => {
      return (
        <Badge variant={row.original.bookable ? 'default' : 'secondary'}>{row.original.bookable ? 'Yes' : 'No'}</Badge>
      );
    },
  },
];
